import { render, staticRenderFns } from "./NewslettersRow.vue?vue&type=template&id=cb29bcec"
import script from "./NewslettersRow.vue?vue&type=script&lang=js"
export * from "./NewslettersRow.vue?vue&type=script&lang=js"
import style0 from "./NewslettersRow.vue?vue&type=style&index=0&id=cb29bcec&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports